import { Layout, Skeleton, Badge, List, Card } from "antd";
import { observer } from "mobx-react-lite";
import React, { useEffect, useContext } from "react";

import PermissionStore from "../../admin/permission/store/permissionStore";
import { getAntIconEquivalent } from "../../../Utility/modules/helpers";
import Title from "antd/lib/typography/Title";
import Text from "antd/lib/typography/Text";
import { PermissionItem } from "./PermissionItem";

const { Content, Sider } = Layout;
const _ = require("underscore");

export const UserPermission = observer(() => {
  const permissionStore = useContext(PermissionStore);

  useEffect(() => {
    async function loadUserGroupsAndPermissions(params) {
      try {
        await permissionStore.getUserRoles();
        await permissionStore.getUserPermissions();
      } catch (error) {
      } finally {
        permissionStore.isloadingUserRoles = false;
        permissionStore.isloadingUserPermissions = false;
      }
    }
    loadUserGroupsAndPermissions();
  }, []);

  return (
    <Layout>
      <Content>
        <Layout style={{ background: "#fff" }}>
          <Sider
            width={400}
            style={{ background: "#fff", paddingLeft: "20px", width: "30%" }}
          >
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div
                  className="ms-Grid-col ms-sm12"
                  style={{
                    marginBottom: "12px",
                    color: "rgba(0,0,0,.85)",
                    fontWeight: "500",
                    fontSize: "20px",
                    lineHeight: "28px",
                  }}
                >
                  My Account Group
                  {permissionStore.userPriviledges.size > 0 ? "s" : null}
                  <Badge count={permissionStore.userPriviledges.size} />
                </div>
              </div>

              <div className="ms-Grid-row ">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  {permissionStore.isloadingUserRoles ? (
                    <>
                      <Skeleton active />
                      <Skeleton active />
                      <Skeleton active />
                    </>
                  ) : (
                    <List
                      itemLayout="horizontal"
                      dataSource={[...permissionStore.userPriviledges.values()]}
                      size="small"
                      style={{ width: "95%" }}
                      renderItem={(item) => (
                        <List.Item>
                          <List.Item.Meta
                            title={<span>{item.name}</span>}
                            description={item.description}
                          />
                        </List.Item>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
          </Sider>
          <Content>
            <div className="ms-Grid" dir="ltr">
              <div className="ms-Grid-row">
                <div className="ms-Grid-col ms-sm12">
                  {" "}
                  <div className="ms-Grid" dir="ltr">
                    <div className="ms-Grid-row">
                      <div
                        className="ms-Grid-col ms-sm12"
                        style={{
                          marginBottom: "12px",
                          color: "rgba(0,0,0,.85)",
                          fontWeight: "500",
                          fontSize: "20px",
                          lineHeight: "28px",
                        }}
                      >
                        My Privileges and Permissions
                      </div>
                    </div>

                    <div
                      className="ms-Grid-row"
                      style={{ paddingLeft: "24px" }}
                    >
                      <div className="ms-Grid-col ms-sm12">
                        {!permissionStore.isloadingUserPermissions ? (
                          <div className="ms-Grid" dir="ltr">
                            <div className="ms-Grid-row">
                              <div className="ms-Grid-col ms-sm12">
                                <List
                                  itemLayout="horizontal"
                                  grid={{
                                    gutter: 16,
                                    xs: 1,
                                    sm: 2,
                                    md: 4,
                                    lg: 4,
                                    xl: 6,
                                    xxl: 3,
                                  }}
                                  dataSource={[
                                    ...permissionStore.userPermissions.values(),
                                  ]}
                                  renderItem={(item) => (
                                    <List.Item>
                                      <Card
                                        title={
                                          <div>
                                            {getAntIconEquivalent(
                                              item.menuIcon
                                            )}{" "}
                                            <Title
                                              level={4}
                                              style={{
                                                display: "inline",
                                                fontSize: "14px",
                                              }}
                                            >
                                              {item.menu}
                                            </Title>
                                          </div>
                                        }
                                      >
                                        <div className="ms-Grid" dir="ltr">
                                          <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm6">
                                              View Data
                                            </div>
                                            <div className="ms-Grid-col ms-sm6">
                                              <PermissionItem
                                                permval={item.canView}
                                              />
                                            </div>
                                          </div>
                                          <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm6">
                                              Modify Data
                                            </div>
                                            <div className="ms-Grid-col ms-sm6">
                                              <PermissionItem
                                                permval={item.canUpdate}
                                              />
                                            </div>
                                          </div>
                                          <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm6">
                                              Delete Data
                                            </div>
                                            <div className="ms-Grid-col ms-sm6">
                                              <PermissionItem
                                                permval={item.canDelete}
                                              />
                                            </div>
                                          </div>
                                          <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm6">
                                              Upload Data
                                            </div>
                                            <div className="ms-Grid-col ms-sm6">
                                              <PermissionItem
                                                permval={item.canExecute}
                                              />
                                            </div>
                                          </div>
                                          <div className="ms-Grid-row">
                                            <div className="ms-Grid-col ms-sm6">
                                              Approve Data
                                            </div>
                                            <div className="ms-Grid-col ms-sm6">
                                              <PermissionItem
                                                permval={item.canApprove}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                        <div className="ms-Grid" dir="ltr">
                                          <div className="ms-Grid-row">
                                            <div
                                              className="ms-Grid-col ms-sm12 ms-fontSize-12"
                                              style={{
                                                paddingTop: "5px",
                                                color: "#CBD5E0",
                                              }}
                                            >
                                              {item.display}
                                            </div>
                                          </div>
                                        </div>
                                      </Card>
                                    </List.Item>
                                  )}
                                />
                              </div>
                            </div>
                          </div>
                        ) : (
                          <>
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                            <Skeleton active />
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Content>
        </Layout>
      </Content>
    </Layout>
  );
});

